import { Inline, Stack, H4 } from "@adfenix/alexandria";
import styled from "styled-components";
import { UploadButton } from "components/UploadButton/UploadButton";
import { useState } from "react";
import { addUploadedImage } from "api/services/mediaService";
import { handleUploadImage } from "lib/cloudinary/handleUploadImage";
import { toast } from "react-toastify";
import { Image } from "./Image";
import { useTranslation } from "react-i18next";

const StyledInline = styled(Inline)`
  position: relative;
  ${({ theme }) => theme.breakpoints.mobileAndLower} {
    justify-content: center;
    justify-items: center;
  }
`;

export const ImageUpload = ({
  image,
  setImage,
  name,
  isFetching
}: {
  image: string | undefined;
  setImage: (image: string) => void;
  name: string;
  isFetching: boolean;
}) => {
  const { t } = useTranslation();

  const [isUploading, setIsUploading] = useState(false);

  return (
    <Stack spacing="xs">
      <H4>{name}</H4>
      <StyledInline
        alignItems="center"
        gap="gutter"
        justifyContent="space-between"
      >
        <Image src={image} loading={isUploading || isFetching} />

        <Stack spacing="xs">
          <UploadButton
            accept="image/*"
            id="agent-image-upload"
            testId="agent-image-upload"
            onImageUpload={async x => {
              setIsUploading(true);
              const uploadedImage = await handleUploadImage(x);
              if (!uploadedImage) {
                toast.error(t("agentprofile.imageupload.failure"));
                return;
              }

              addUploadedImage({
                originalUrl: uploadedImage.url,
                uploadedUrl: uploadedImage.url,
                externalId: uploadedImage.public_id
                // Silent catch here since the feature works without the upload to media-service
              }).catch(() => {});

              setImage(uploadedImage.url);
              setIsUploading(false);
            }}
          />
        </Stack>
      </StyledInline>
    </Stack>
  );
};
